import React from 'react';
import * as styles from './CopyableReviewList.module.scss';
import { FormControl, Text, RadioButton, RadioGroup } from 'components/core';
import { Stack } from 'components/layout';
import { dateString } from 'pages/StudyList/util';
import { ReviewWithCopyableTemplate } from 'query/review/';

type CopyableReviewListProps = {
  reviews: ReviewWithCopyableTemplate[];
  onChange: (id: number) => void;
  error?: string;
  'aria-label': string;
};

export function CopyableReviewList({
  reviews,
  onChange,
  error,
  'aria-label': ariaLabel,
}: CopyableReviewListProps) {
  if (reviews.length === 0) {
    return (
      <div className={styles.EmptyState}>
        <Text size="md" variant="weak" component="span">
          No reviews yet. They’ll appear once you’re invited or create a review
          with a published template.
        </Text>
      </div>
    );
  }

  return (
    <FormControl
      className={styles.ReviewList}
      error={
        error ? (
          <Text size="sm" variant="danger">
            {error}
          </Text>
        ) : undefined
      }
    >
      <RadioGroup
        ariaLabel={ariaLabel}
        name="copyable-review"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(parseInt(e.target.value, 10))
        }
      >
        <div className={styles.ReviewItems}>
          {reviews.map((review) => (
            <RadioButton
              key={review.id}
              value={String(review.id)}
              className={styles.ReviewItem}
              size="md"
            >
              <Stack spacing={1} className={styles.Content}>
                <Text size="sm" variant="weak" component="span">
                  {dateString(review.created_at)}
                </Text>
                <Text size="md" variant="brand" component="span">
                  {review.title}
                </Text>
              </Stack>
            </RadioButton>
          ))}
        </div>
      </RadioGroup>
    </FormControl>
  );
}
